export default __webpack_public_path__ + "static/media/iconly_bulk_setting.b080c7d2.svg";